<template>
  <div class="widget-container">
    <InfoCard v-for="(card, index) in cards" :key="index" :title="card.title" :icon="card.icon" :value="card.value"
      :percent="card.percent" :isloading="isloading" />
  </div>
</template>

<script>
import urlApi from '../../router/urlApiV2'
import InfoCard from '../core/InfoCard.vue';

export default {
  name: 'InfoWidgets',
  data() {
    return {
      novosAlunos: '',
      novosBoletos: '',
      totalAlunos: '',
      aulasCanceladas: '',
      isloading: true,
    }
  },
  components: {
    InfoCard,
  },
  async created() {
    await Promise.all([
      this.getNewStudents(),
      this.getNewBoletos(),
      this.getCanceledClasses(),
      this.getTotalStudents(),
    ])

    this.isloading = false
  },
  methods: {
    async getNewStudents() {
      await this.$http.get(urlApi + '/alunos/consultar/cadastros-ultima-semana')
        .then(function (response) {
          this.novosAlunos = response.data.dados;
        })
    },
    async getNewBoletos() {
      await this.$http.get(urlApi + '/boleto/ultimos-boletos')
        .then(function (response) {
          this.novosBoletos = response.data.dados;
        })
    },

    async getCanceledClasses() {
      await this.$http.get(urlApi + '/aulas/canceladas')
        .then(function (response) {
          this.aulasCanceladas = response.data.dados;
        })
    },
    async getTotalStudents() {
      await this.$http.get(urlApi + '/alunos/consultar/total')
        .then(function (response) {
          this.totalAlunos = response.data.dados;
        })
    },
  },
  computed: {
    cards() {
      return [
        {
          title: 'Novos alunos',
          icon: 'person-plus',
          value: this.novosAlunos.currentWeekStudents,
          percent: {
            value: this.novosAlunos ? Math.abs(this.novosAlunos.percentageGrowth).toFixed(2) : 0,
            status: this.novosAlunos.percentageGrowth >= 0 ? 'positive' : 'negative'
          }
        },
        {
          title: 'Boletos emitidos',
          icon: 'cash',
          value: this.novosBoletos.currentWeekBoletos,
          percent: {
            value: this.novosBoletos ? Math.abs(this.novosBoletos.percentageGrowth).toFixed(2) : 0,
            status: this.novosBoletos.percentageGrowth >= 0 ? 'positive' : 'negative'
          }
        },
        {
          title: 'Cancelamentos',
          icon: 'cancel',
          value: this.aulasCanceladas.totalCurrentWeekClasses,
          percent: {
            value: this.aulasCanceladas ? Math.abs(this.aulasCanceladas.percentageGrowth).toFixed(2) : 0,
            status: this.aulasCanceladas.percentageGrowth >= 0 ? 'positive' : 'negative'
          }
        },
        {
          title: 'Total de alunos',
          icon: 'group',
          value: this.totalAlunos.totalStudents,
          percent: {
            value: this.totalAlunos ? Math.abs(this.totalAlunos.percentageGrowth).toFixed(2) : 0,
            status: this.totalAlunos.percentageGrowth >= 0 ? 'positive' : 'negative'
          }
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-container {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  flex-wrap: wrap;
}
</style>